export const WAS_APP_PAUSED = "wasAppPaused";
export const IS_SIGNUP = "isSignup";
export const DISMISSED_STRIPE_POPUP = "dismissedStripePopup";
